// Axios instance + auth context for India's Inking admin portal.
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token from localStorage on every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("iis_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function saveToken(token) {
  localStorage.setItem("iis_admin_token", token);
}

export function clearToken() {
  localStorage.removeItem("iis_admin_token");
}

export function getToken() {
  return localStorage.getItem("iis_admin_token");
}

// FastAPI 422 validation responses include arrays of {msg, loc} objects.
// React crashes if those are rendered directly. Always normalize before set.
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
